import React, { memo, Fragment, useCallback, useMemo } from 'react';
import { createUseStyles, RadioBoxGroup } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from "../../../../lib/Web5Context";
import { ENTITIES } from "../../../../lib/constants";
import StepContent from "../StepContent";
import UpdateOptions from "./UpdateOptions";
import IdentifierPicker from "./IdentifierPicker";
import { ENTITIES_DATA } from "../../constants";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'ImportType');
const ImportType = _ref => {
  let {
    entityName,
    entityLabel,
    data,
    matchBy,
    advancedType,
    imgImportsName,
    imgImportsFmId,
    imgImportsExtId,
    onClickIsAdvanced,
    onClickIdentifier,
    onChangeIdType,
    onChangeSyncNames,
    syncNamesList,
    onChangeImportType,
    totals
  } = _ref;
  const classes = useStyles();
  const {
    t
  } = useWeb5Context();
  const getIdentifierPicker = useCallback(_ref2 => {
    let {
      withMarginTop,
      newAdvancedType
    } = _ref2;
    if (entityName !== ENTITIES.CONTACTS.name && entityName !== ENTITIES.OPPORTUNITIES.name) {
      return;
    }
    return /*#__PURE__*/React.createElement(IdentifierPicker, {
      setIsAdvanced: bool => onClickIsAdvanced(bool, newAdvancedType),
      isAdvanced: advancedType && advancedType === newAdvancedType,
      setIdentifier: onClickIdentifier,
      identifier: matchBy,
      withMarginTop: withMarginTop,
      imgImportsName: imgImportsName,
      imgImportsFmId: imgImportsFmId,
      imgImportsExtId: imgImportsExtId
    });
  }, [entityName, matchBy, advancedType, onClickIsAdvanced, onClickIdentifier, imgImportsName, imgImportsFmId, imgImportsExtId]);
  const children = useMemo(() => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UpdateOptions, {
      idType: data.idType,
      onChangeIdType: onChangeIdType,
      syncNames: syncNamesList,
      onChangeSyncNames: onChangeSyncNames,
      fields: data.fields,
      entityLabel: entityLabel
    }), getIdentifierPicker({
      withMarginTop: true,
      newAdvancedType: 'update'
    }));
  }, [data.fields, data.idType, onChangeIdType, onChangeSyncNames, syncNamesList, getIdentifierPicker, entityLabel]);
  const options = useMemo(() => {
    var _ENTITIES_DATA$entity, _ENTITIES_DATA$entity2;
    const totalOptions = [{
      icon: ((_ENTITIES_DATA$entity = ENTITIES_DATA[entityName]) === null || _ENTITIES_DATA$entity === void 0 ? void 0 : _ENTITIES_DATA$entity.addIcon) || 'valueListAdd',
      title: t('cfm_label_import_type_create', [entityLabel]),
      text: t('cfm_label_import_type_create_subtitle', [entityLabel]),
      value: 'create',
      className: 'import-export__import-type--create',
      children: getIdentifierPicker({
        newAdvancedType: 'create'
      })
    }];
    if (totals) totalOptions.push({
      icon: ((_ENTITIES_DATA$entity2 = ENTITIES_DATA[entityName]) === null || _ENTITIES_DATA$entity2 === void 0 ? void 0 : _ENTITIES_DATA$entity2.editIcon) || 'valueListEdit',
      title: t('cfm_label_import_type_update', [entityLabel]),
      text: t('cfm_label_import_type_update_subtitle', [entityLabel]),
      value: 'update',
      className: 'import-export__import-type--update',
      children
    });
    return totalOptions;
  }, [entityName, t, entityLabel, getIdentifierPicker, children, totals]);
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.stepWrapper
  }, /*#__PURE__*/React.createElement(StepContent, null, /*#__PURE__*/React.createElement(RadioBoxGroup, {
    className: classes.importTypeBox,
    options: options,
    onChange: onChangeImportType,
    value: data.importType
  }))));
};
ImportType.propImportTypes = {};
export default /*#__PURE__*/memo(ImportType);